import { scrollTo } from '../global/scrollTo'
export const collectionOfCollectionsNav = () => {

  //Set up Intersection Handler for desktop and mobile
  const intersectionHandler = (type, el, arr, th) => {
    const intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (isIntersecting) {
          if (type === 'mob') {
            el.value = target.getAttribute('id')
          }
          if (type === 'desktop') {
            const activeLink = el.find(active => active.classList.contains('active'));
            if (activeLink && activeLink.handle !== target.getAttribute('id')) {
              activeLink.classList.remove('active')
            }
            el.find(nav => nav.dataset.handle === target.getAttribute('id')).classList.add('active')
          }
        } 
      })
    }, {
      rootMargin: '0px',
      threshold: th
    })
    arr.forEach(element => element ? intersectionObserver.observe(element) : null)
  }

  //Set up variables
  const selectNode = (el) => document.querySelector(el);
  const selectNodes = (el) => document.querySelectorAll(el)

  const fixedNav = selectNode('.collection-of-collections-nav-wrapper');
  const desktopNav = [...selectNodes('.coc-nav-list li')];
  const desktopNavList = selectNode('.coc-nav-list')
  const pageHeader = selectNode('header.header-section');
  const hiddenNavDivSelect = selectNode('.coc-nav select');
  const navItems = [...selectNodes('span[data-all-links]')];
  const collectionSections = [selectNode('.collection-of-collections-essential'), ...selectNodes('.collection-of-collections-products-collection')];
  
  //Desktop Select
  if(desktopNav) {
    desktopNav.forEach(nav => {
      nav.addEventListener('click', function (e) {
        e.preventDefault();
        const { handle } = nav.dataset;
        const { height } = fixedNav.getBoundingClientRect();
        const target = `#${handle}`;
        const options = {
          top: window.pageYOffset === 0 ? selectNode(target).offsetTop - (height + pageHeader.getBoundingClientRect().height / 2) : selectNode(target).offsetTop - height
        }
        scrollTo(target, options)
      })
    })
  }
  //Mobile Select
  if (hiddenNavDivSelect) {
    //Build options for select dropdown
    navItems.forEach(item => {
      const option = document.createElement('option');
      option.value = item.dataset.allLinks;
      option.innerText = item.dataset.title;
      hiddenNavDivSelect.append(option);
    });
    
    hiddenNavDivSelect.addEventListener('change', function (e) {
      hiddenNavDivSelect.value = e.target.value;
      const selected = [...this.querySelectorAll('option')].find(item => item.value === e.target.value);
      if (selected) {
        const target = `#${selected.value}`;
        const { height } = fixedNav.getBoundingClientRect();
        const options = {
          top: window.pageYOffset === 0 ? selectNode(target).offsetTop - (height + pageHeader.getBoundingClientRect().height) : selectNode(target).offsetTop - height
        }
        scrollTo(target, options)
      }
    })
  }

  //Set position fixed on both desktop and mobile nav bar

  if (fixedNav && pageHeader) {
    if (getComputedStyle(hiddenNavDivSelect).display !== 'none') intersectionHandler('mob', hiddenNavDivSelect, collectionSections, 0.65);
    if (getComputedStyle(desktopNavList).display !== 'none') intersectionHandler('desktop', desktopNav, collectionSections, 0.7 )
    window.addEventListener('scroll', () => {
      const setSticky = fixedNav.offsetTop;
      const { height } = pageHeader.getBoundingClientRect();
      
      if (window.pageYOffset > setSticky) {
        fixedNav.classList.add('collection-of-collections-nav-wrapper-sticky');
        fixedNav.style.top = `${height}px`
      } else {
        fixedNav.classList.remove('collection-of-collections-nav-wrapper-sticky')
        fixedNav.style.top = 0
      }
    })
  }
}


